(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sample', {
            parent: 'entity',
            url: '/sample',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Sample'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sample/sample.html',
                    controller: 'SampleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
    }

})();
